import { Toaster } from "sonner";
import { useTheme } from "@/store/ThemeContext";

export default function ThemedToaster() {
  const { theme } = useTheme();
  const dark = theme === "dark";
  return (
    <Toaster
      position="bottom-right"
      theme={dark ? "dark" : "light"}
      toastOptions={{
        style: {
          background: dark ? "#221c17" : "#FDFBF7",
          color: dark ? "#E8D8C4" : "#292524",
          border: `1px solid ${dark ? "#3a2f22" : "#E7E5E4"}`,
          fontFamily: "Manrope, sans-serif",
        },
      }}
    />
  );
}
